<template>
  <p class="lead text-muted container" v-if="loading"><i class="fa fa-circle-o-notch fa-spin"/> Loading...</p>
  <ShareLinkInvalidMessage v-else-if="!draftedStatement">
    This link is either invalid, or the present levels statement is no longer shared by its owner. Ask the owner of the present levels statement for a new shareable link.
  </ShareLinkInvalidMessage>
  <CopyTrackWrapper
    v-else
    type="presentlevel"
    :uuid="uuid"
    :demo="true"
    :enforce-quota="false">
    <SharedPageBanner
      v-if="studentName"
      :content-type-label="contentTypeLabel"
      :content-type="contentType"
      :student-name="studentName"
      :user-name="userName"
      :last-updated="lastUpdatedAt"
      :share-link="shareLink"/>

    <div class="container">
      <div class="row">
        <div class="col-md-9 col-lg-8">
          <h1 class="student-header">Present levels drafted for <span class="student-name">{{ studentName }}</span></h1>
          <div class="mdc-card">
            <div class="mdc-card__actions">
              <CopyButton
                @copied="statementCopied"
                btn-class="btn-success"
                :copy-text="draftedStatement"
                success-text="Present levels statement copied"
                error-text="Error copying text. Use Ctrl+C instead.">Copy Statement</CopyButton>
            </div>

            <section class="mdc-card__primary">
              <WikiText
                class="gb-text-3 fs-block"
                :text="draftedStatement"/>
            </section>
          </div>

        </div>
        <div class="col-md-3 col-lg-4"/>
      </div>

      <TermsOfUseFooter />
    </div>
  </CopyTrackWrapper>

</template>

<script>
import { getSharedPresentLevelStudentStatement } from '@/api/presentlevels'
import { CONTENT_TYPES } from '@/util/access_visibility'
import WikiText from '@/components/WikiText'
import SharedPageBanner from '@/components/SharedPageBanner'
import CopyButton from '@/components/CopyButton'
import CopyTrackWrapper from '@/components/CopyTrackWrapper'
import TermsOfUseFooter from '@/components/library/TermsOfUseFooter'
import ShareLinkInvalidMessage from '@/components/library/ShareLinkInvalidMessage'
import { setTitle } from '@/util/title'

export default {
  name: 'SharedPresentLevelsPage',
  components: {
    SharedPageBanner,
    WikiText,
    CopyTrackWrapper,
    CopyButton,
    ShareLinkInvalidMessage,
    TermsOfUseFooter
  },
  props: {
    uuid: {
      required: true,
      type: String
    }
  },
  data() {
    return {
      loading: false,
      draftedStatement: '',
      studentName: '',
      studentUuid: '',
      lastUpdatedAt: '',
      contentTypeLabel: 'present levels statement',
      contentType: CONTENT_TYPES.PRESENTLEVEL,
      enrolledGrade: '',
      areasOfNeed: []
    }
  },
  computed: {
    shareLink() {
      return (
        window.location.origin +
        this.$router.resolve({
          name: 'SharedPresentLevelsPage',
          params: { uuid: this.uuid }
        }).href
      )
    }
  },
  methods: {
    async loadDraftStatement() {
      this.loading = true
      try {
        let plResponse = await getSharedPresentLevelStudentStatement(this.uuid, {
          includeImpacts: true,
          author: true
        })

        this.studentName = plResponse.student.student_name
        this.studentUuid = plResponse.student.student_uuid
        this.enrolledGrade = plResponse.student.enrolled_grade_level
        this.areasOfNeed = plResponse.student.selected_subjects
        this.draftedStatement = plResponse.student.drafted_strengths
        this.lastUpdatedAt = plResponse.student.updated_at
        this.userName = (plResponse.user && plResponse.user.name) || ''

        setTitle(`Shared Present Levels Statement for ${this.studentName}`)

        this.$sendEvent('Viewed Shared Present Levels')
      } catch (err) {
        // TODO: handle error cases
        console.error(err)
      } finally {
        this.loading = false
      }
    },
    statementCopied() {
      this.$sendEvent('Clicked Copy Statement from Drafted')
    }
  },
  eventContext() {
    return {
      plw_uuid: this.uuid,
      plw_enrolled_grade: this.enrolledGrade,
      plw_areas_of_need: this.areasOfNeed,
      plw_is_library: true,

      student_uuid: this.studentUuid
    }
  },
  watch: {
    $route: function() {
      this.loadDraftStatement()
    }
  },
  created() {
    this.loadDraftStatement()
  }
}
</script>

<style lang="scss" scoped>
@import '@material/card/mdc-card';
.student-header {
  .student-name {
    font-style: italic;
    color: #3c9ad5;
  }
}
.mdc-card {
  margin-top: 30px;
  padding: 15px;
  background: #d5eefa;
}
.mdc-card__actions {
  justify-content: flex-end;
}
</style>]
